import { Box } from "@mui/material";
import React from "react";
import {
  BOX_CURTAIN_ROOF_OPENING_FIELDS,
  BOX_FLOOR_FIELDS,
  BOX_LENGTH_FIELDS,
  BOX_ROOF_OPENING_FIELDS,
  BOX_ROOF_TYPE_FIELDS,
  BOX_SPACING_FIELDS,
  BOX_STRUCTURE_DOOR_FIELDS,
  BOX_STRUCTURE_TYPE_FIELDS,
  BOX_WIDTH_FIELDS,
} from "../data";
import { FormFieldControl, FormSection } from "../VehicleDetails/FormControls";
import {
  ActionButtonColumn,
  ActionButtonsColumn,
  CenterOfGravityFields,
  RearOverhangFields,
  StructurePanel,
} from "./FormControls";
import { renderFieldControls, useBoxDetails } from "./hooks/useBoxDetails";
import { useStyles } from "./styles";

const BoxDetails = () => {
  const styles = useStyles();
  const {
    formValues,
    formPrefix,
    updateField,
    usesCompactRoofRow,
    rearWallTypeConfig,
  } = useBoxDetails();

  if (!formValues) {
    return null;
  }

  const fieldProps = { formValues, formPrefix, updateField };

  return (
    <>
      <FormSection titleKey={`${formPrefix}.SECTIONS.BASIC_BOX_DETAILS`} hideTopBorder>
        <Box className={styles.row}>
          <Box className={styles.grid3} sx={{ flex: 1 }}>
            {renderFieldControls(BOX_SPACING_FIELDS, formValues, updateField)}
          </Box>
          <ActionButtonsColumn
            formPrefix={formPrefix}
            buttonKeys={["SET_LAST_SPACING", "SET_RECOMMENDED_SPACING"]}
          />
        </Box>

        <Box className={styles.row}>
          <Box className={styles.grid4} sx={{ flex: 1 }}>
            {renderFieldControls(BOX_LENGTH_FIELDS, formValues, updateField)}
          </Box>
          <ActionButtonColumn formPrefix={formPrefix} buttonKey="MAX_LENGTH" />
        </Box>

        <CenterOfGravityFields {...fieldProps} />
        <RearOverhangFields {...fieldProps} />

        <Box className={styles.row}>
          <Box className={styles.grid5} sx={{ flex: 1 }}>
            {renderFieldControls(BOX_WIDTH_FIELDS, formValues, updateField)}
          </Box>
          <ActionButtonColumn formPrefix={formPrefix} buttonKey="MAX_WIDTH" />
        </Box>

        <Box className={styles.grid3}>
          {renderFieldControls(BOX_FLOOR_FIELDS, formValues, updateField)}
        </Box>
      </FormSection>

      <FormSection titleKey={`${formPrefix}.SECTIONS.BOX_STRUCTURE`}>
        <Box className={styles.grid4}>
          {renderFieldControls(BOX_STRUCTURE_TYPE_FIELDS, formValues, updateField)}
          <FormFieldControl
            config={rearWallTypeConfig}
            value={formValues.rearWallType}
            onChange={(value) => updateField("rearWallType", value)}
          />
        </Box>

        <Box className={styles.gridStructureDoors}>
          {renderFieldControls(BOX_STRUCTURE_DOOR_FIELDS, formValues, updateField)}
        </Box>

        <StructurePanel {...fieldProps} />
      </FormSection>

      <FormSection titleKey={`${formPrefix}.SECTIONS.ROOF`}>
        <Box className={styles.grid3}>
          {renderFieldControls(BOX_ROOF_TYPE_FIELDS, formValues, updateField)}
        </Box>

        {usesCompactRoofRow ? (
          <Box className={styles.gridCurtainRoofOpenings}>
            {renderFieldControls(
              BOX_CURTAIN_ROOF_OPENING_FIELDS,
              formValues,
              updateField
            )}
            <ActionButtonColumn formPrefix={formPrefix} buttonKey="MAX_WIDTH" />
          </Box>
        ) : (
          <Box className={styles.gridRoofOpenings}>
            {renderFieldControls(
              BOX_ROOF_OPENING_FIELDS.slice(0, 2),
              formValues,
              updateField
            )}
            <ActionButtonColumn formPrefix={formPrefix} buttonKey="MAX_LIGHT_OPENING" />
            {renderFieldControls(
              BOX_ROOF_OPENING_FIELDS.slice(2),
              formValues,
              updateField
            )}
          </Box>
        )}
      </FormSection>
    </>
  );
};

export default BoxDetails;
